import I18n from "../../I18n";

const mapCard = (json) => {
    const { ID, ReportName, ReportActiveInProject } = json;
    return [
        [
            {
                labels: ["id"],
                value: ID,
                type: "string",
                align: "align-left",
                basis: "5%",
            },
        ],
        [
            {
                labels: ["ReportName"],
                value: ReportName,
                type: "string",
                align: "align-left",
                basis: "70%",
            },
        ],
        [
            {
                labels: ["Active"],
                value:
                    ReportActiveInProject && ReportActiveInProject === 1
                        ? I18n.translate`Yes`
                        : I18n.translate`No`,
                type: "string",
                align: "align-left",
                basis: "10%",
            },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        link: {
            to: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix/custom_reports/${json.id}`,
        },
    };
};

const header = [
    { label: ["Id"], align: "left", columnName: "id", basis: "5%" },
    { label: ["Report Name"], align: "left", columnName: "ReportName", basis: "70%" },
    { label: ["Active for this project?"], align: "left", columnName: "Active", basis: "10%" },
];

const customreportMapper = {
    map: mapper,
    header,
};

export default customreportMapper;
